import type { TypedUseSelectorHook } from "react-redux";

import { useDispatch, useSelector } from "react-redux";

import type { ReduxDispatch, ReduxState } from "./reduxStore";

export const useTypedDispatch: () => ReduxDispatch = useDispatch;
export const useTypedSelector: TypedUseSelectorHook<ReduxState> = useSelector;
